module.exports = __webpack_public_path__ + "static/media/0.f657ed38.png";